import { makeAutoObservable } from "mobx";
import {IChangeable} from "../../../stores/types";
import { IReturnMethodIntegrationConnection } from "../return-method-types";

interface IReturnMethodIntegrationConnectionChanges extends Partial<IReturnMethodIntegrationConnection> {}

class ReturnMethodIntegrationConnectionStore implements IChangeable<IReturnMethodIntegrationConnection> {
    private _model: IReturnMethodIntegrationConnection = {} as IReturnMethodIntegrationConnection;
    private _changes: IReturnMethodIntegrationConnectionChanges = {};

    constructor(model?: IReturnMethodIntegrationConnection) {
        makeAutoObservable(this);
        if (model) {
            this._setModel(model);
        }
	}

    public get integration_connection_id() { return this._changes?.integration_connection_id ?? this._model?.integration_connection_id; };

    public setDeleted(v: boolean) { 
        if (v) {
            this._changes._deleted = v; 
            return;
        }
        delete this._changes._deleted;
    }

    public setChanges(changes: IReturnMethodIntegrationConnectionChanges): void {
        this._changes = changes;
    }

    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {};  
    }

    public getUpdatedModel(): IReturnMethodIntegrationConnection {
        return {
            ...this._model, 
            ...this._changes,
            _has_changes: this.hasChanges(),
        }
    }

    private _setModel(model: IReturnMethodIntegrationConnection): void {
        this._model = model;
    }
}

export default ReturnMethodIntegrationConnectionStore;